{
  "addButtonLabel": "添加药物",
  "dose": "剂量",
  "dosePlaceholder": "e.g. 500mg or 1 tablet",
  "dropHere": "请拖放到此处",
  "dropText": "<p>{{fileExtensions}} 或 {{fileExtension}}，大小最多 {{mb}}MB</p>",
  "dropTitle": "<p><strong>上传文件</strong>或拖放</p>",
  "frequency": "频率",
  "manuallyText": "<strong>手动添加药物</strong><p>一次添加一种药物。请填写名称、剂量和服用频率。</p>",
  "medicationName": "药物名称",
  "medicationPlaceholder": "<p><strong>请用英文填写。</strong><br/>例如：Metformin – 500mg morning and night</p>",
  "nextLabel": "$t(common:next): <b>病史</b>",
  "saveButton": "保存药物",
  "select": {
    "as-needed": "根据需要",
    "once-daily": "每日一次",
    "three-time-daily": "每日三次",
    "twice-daily": "每日两次"
  },
  "text": "<p>请告诉我们您目前正在服用的任何药物、吸入器、注射剂或补充剂。</p>\n<p>您可以上传一份清单或手动添加。</p>",
  "title": "药物",
  "uploadText": "<strong>上传处方或清单</strong>\n<p>如果您有来自全科医生或药房的清单，请上传照片或 PDF 文件。</p>"
}
